/**
 * Typings for all drivers ranking type
 *
 * - Total point
 * - Free practice sessions results
 * - Qualifying results
 * - race starting grid
 * - race results
 */
export const DRIVERS_RANKING_POINTS = 'total-points';
export const DRIVERS_RANKING_FREE_PRACTICE_RESULTS = 'free-practice-results';
export const DRIVERS_RANKING_QUALIFYING_RESULTS = 'qualifying-results';
export const DRIVERS_RANKING_RACE_STARTING_GRID = 'race-starting-grid';
export const DRIVERS_RANKING_RACE_RESULTS = 'race-results';

export type DriversRankingVariants =
  | 'total-points'
  | 'free-practice-results'
  | 'qualifying-results'
  | 'race-starting-grid'
  | 'race-results';

export const driversRankingVariantList: DriversRankingVariants[] = [
  DRIVERS_RANKING_POINTS,
  DRIVERS_RANKING_FREE_PRACTICE_RESULTS,
  DRIVERS_RANKING_QUALIFYING_RESULTS,
  DRIVERS_RANKING_RACE_STARTING_GRID,
  DRIVERS_RANKING_RACE_RESULTS,
];
